const initialState = {
  list_of_myPortfolios: [],
};

function myPortfolios(
  state = JSON.parse(JSON.stringify(initialState)),
  action
) {
  const { payload, type } = action;

  let newState = Object.assign({}, state);

  switch (type) {
    case "SET_LIST_OF_MYPORTFOLIOS":
      newState.list_of_myPortfolios = payload;
      break;

    default:
      return state;
  }

  return newState;
}

export default myPortfolios;



// WEBPACK FOOTER //
// ./src/reducers/myPortfolios.reducer.js